/* pd-level-up — bundle widget custom element
   原 sections/pd-level-up.liquid 的 inline IIFE 抽出，按多 instance 安全重构：
   - 每个 <pd-level-up> 元素独立 state / rowEls / tabs
   - connectedCallback 自动初始化，shopify:section:load 自然触发 */
(function () {
  'use strict';
  if (window.customElements.get('pd-level-up')) return;

  // 切 tab 时，隐藏 group（display:none）里的懒加载图不会下载，切换才请求 → 白屏。
  // 空闲时提前拉好：lazysizes 图（class="lazyload"）调 loader.unveil()，原生 lazy 图转 eager。
  function preloadLazyImages(root) {
    var imgs = root.querySelectorAll('img.lazyload, img[loading="lazy"]');
    if (!imgs.length) return;
    var lz = window.lazySizes;
    var run = function () {
      imgs.forEach(function (img) {
        if (img.classList.contains('lazyload')) {
          if (lz && lz.loader && lz.loader.unveil) lz.loader.unveil(img);
        } else if (img.getAttribute('loading') === 'lazy') {
          img.loading = 'eager';
        }
      });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 600);
  }

  var MIN_ROWS = 4;
  var cartSectionsToRender = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  // GA4 add_to_cart 上报：bundle 加购走自定义 fetch，绕过 ga4-script.liquid 的 click 监听，
  // 这里直推 dataLayer 兜底。reset → push 双步模拟 GA4Initializer.push。
  function pdLuPushAddToCartGA4(items, moduleName) {
    if (!items || !items.length) return;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var ga4Items = items.map(function (it, idx) {
      var unit = it && (it.final_price != null ? it.final_price : it.price);
      var price = typeof unit === 'number' ? unit / 100 : 0;
      var qty = Number(it && it.quantity) || 1;
      return {
        item_id: (it && (it.product_id || it.id)) || '',
        item_name: (it && (it.product_title || it.title)) || '',
        item_variant: (it && it.variant_title) || '',
        item_brand: 'Speediance',
        item_category: 'product',
        price: price,
        quantity: qty,
        index: idx
      };
    });
    var value = ga4Items.reduce(function (s, it) {
      return s + (Number(it.price) || 0) * (Number(it.quantity) || 1);
    }, 0);
    var payload = {
      event: 'ga4Event',
      event_name: 'add_to_cart',
      event_parameters: {
        currency: currency,
        module_name: moduleName || 'pd_level_up',
        value: value,
        items: ga4Items
      }
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push(payload);
  }

  class PdLevelUp extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      this.navContainer = this.querySelector('[data-pd-lu-tabs-container]');
      this.groups = this.querySelectorAll('[data-pd-lu-group-id]');
      this.listEl = this.querySelector('[data-pd-lu-list]');
      this.countEl = this.querySelector('[data-pd-lu-count]');
      this.totalEl = this.querySelector('[data-pd-lu-total]');
      this.ctaEl = this.querySelector('[data-pd-lu-cta-add]');
      this.state = {};
      this.rowEls = {};
      this.tabs = [];

      this._onResize = this._updateScrollFade.bind(this);
      if (this.listEl) {
        this.listEl.addEventListener('scroll', this._onResize, { passive: true });
      }
      window.addEventListener('resize', this._onResize);

      var self = this;
      // event delegation：accessory 卡片的 + 按钮 click 通过冒泡到 host 捕获。
      // 即使 theme block 渲染时 Shopify 在 block 外包了 wrapper、或 DOM 异步插入，都不影响。
      this._onAccessoryClick = function (e) {
        var btn = e.target.closest && e.target.closest('[data-pd-lu-add]');
        if (!btn || !self.contains(btn)) return;
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        var c = btn.closest('[data-pd-lu-item-id]');
        if (!c) return;
        self._addItemFromCard(c);
      };
      this.addEventListener('click', this._onAccessoryClick);

      if (this.ctaEl) {
        this.ctaEl.addEventListener('click', this._onCtaAdd.bind(this));
      }

      this._buildNav();
      if (this.groups.length > 0) {
        this._filterTab(this.groups[0].getAttribute('data-pd-lu-group-id'));
      }
      this._render();

      preloadLazyImages(this);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
    }

    _buildNav() {
      if (!this.navContainer) return;
      this.navContainer.innerHTML = '';
      var self = this;
      this.groups.forEach(function (g, i) {
        var id = g.getAttribute('data-pd-lu-group-id');
        var label = g.getAttribute('data-pd-lu-group-label') || '';
        var li = document.createElement('li');
        li.className = 'pd-level-up__tab-item';
        li.setAttribute('role', 'presentation');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pd-level-up__tab' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('data-pd-lu-tab', id);
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.textContent = label;
        btn.addEventListener('click', function () { self._filterTab(id); });
        li.appendChild(btn);
        self.navContainer.appendChild(li);
      });
      this.tabs = Array.prototype.slice.call(this.navContainer.querySelectorAll('[data-pd-lu-tab]'));
    }

    _filterTab(id) {
      this.tabs.forEach(function (b) {
        var active = b.getAttribute('data-pd-lu-tab') === id;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.groups.forEach(function (g) {
        g.classList.toggle('pd-level-up__tab-group--hidden', g.getAttribute('data-pd-lu-group-id') !== id);
      });
    }

    _addItemFromCard(c) {
      var id = c.getAttribute('data-pd-lu-item-id');
      if (!id) return;
      var variantId = c.getAttribute('data-pd-lu-item-variant-id') || '';
      var name = c.getAttribute('data-pd-lu-item-name') || '';
      // price 单位 = cents（整数），与 Shopify 标准一致；total 用整数累加避免浮点误差
      var price = parseInt(c.getAttribute('data-pd-lu-item-price') || '0', 10);
      var priceDisplay = c.getAttribute('data-pd-lu-item-price-display') || '';
      var image = c.getAttribute('data-pd-lu-item-image') || '';
      if (!this.state[id]) this.state[id] = { variantId: variantId, name: name, price: price, priceDisplay: priceDisplay, image: image, qty: 0 };
      this.state[id].qty += 1;
      this._render();
      if (name) this._announce(name + ' added to bundle');
    }

    _announce(msg) {
      if (!this._liveRegion) {
        this._liveRegion = document.createElement('div');
        this._liveRegion.className = 'visually-hidden';
        this._liveRegion.setAttribute('aria-live', 'polite');
        this._liveRegion.setAttribute('aria-atomic', 'true');
        this.appendChild(this._liveRegion);
      }
      this._liveRegion.textContent = msg;
    }

    _createRow(id, row) {
      var self = this;
      var li = document.createElement('li');
      li.className = 'pd-level-up__widget-row';
      var imgHtml = row.image
        ? '<span class="pd-level-up__widget-row-img"><img src="' + escapeHtml(row.image) + '" alt="" decoding="async"></span>'
        : '<span class="pd-level-up__widget-row-img pd-level-up__widget-row-img--empty" aria-hidden="true"></span>';
      li.innerHTML =
        imgHtml +
        '<span class="pd-level-up__widget-row-body">' +
          '<span class="pd-level-up__widget-row-name">' + escapeHtml(row.name) + '</span>' +
          '<span class="pd-level-up__widget-row-price">' + row.priceDisplay + '</span>' +
        '</span>' +
        '<span class="pd-level-up__widget-row-qty">' +
          '<button type="button" data-act="dec" aria-label="Decrease">−</button>' +
          '<span class="pd-level-up__widget-row-qty-num">' + row.qty + '</span>' +
          '<button type="button" data-act="inc" aria-label="Increase">+</button>' +
        '</span>';
      li.querySelector('[data-act="dec"]').addEventListener('click', function () {
        if (!self.state[id]) return;
        self.state[id].qty = Math.max(0, self.state[id].qty - 1);
        self._render();
      });
      li.querySelector('[data-act="inc"]').addEventListener('click', function () {
        if (!self.state[id]) return;
        self.state[id].qty += 1;
        self._render();
      });
      return li;
    }

    // 占位 row 每次按需补/减一行，避免整个列表重建
    _syncEmptyRows(needed) {
      var current = this.listEl.querySelectorAll('.pd-level-up__widget-row--empty');
      var have = current.length;
      if (have === needed) return;
      if (have < needed) {
        for (var i = 0; i < needed - have; i++) {
          var emptyLi = document.createElement('li');
          emptyLi.className = 'pd-level-up__widget-row pd-level-up__widget-row--empty';
          emptyLi.setAttribute('aria-hidden', 'true');
          this.listEl.appendChild(emptyLi);
        }
      } else {
        for (var j = 0; j < have - needed; j++) {
          var last = current[have - 1 - j];
          if (last && last.parentNode) last.parentNode.removeChild(last);
        }
      }
    }

    _render() {
      if (!this.listEl) return;
      var self = this;
      var total = 0;
      var n = 0;
      var filledCount = 0;
      var seen = {};
      var firstEmpty = this.listEl.querySelector('.pd-level-up__widget-row--empty');

      Object.keys(this.state).forEach(function (id) {
        var row = self.state[id];
        if (!row || row.qty <= 0) return;
        seen[id] = true;
        n += row.qty;
        total += row.qty * row.price;
        filledCount++;

        var li = self.rowEls[id];
        if (!li) {
          li = self._createRow(id, row);
          self.rowEls[id] = li;
          self.listEl.insertBefore(li, firstEmpty);
        } else {
          // 已存在 → 只更新 qty 数字，图片/名字/价格不动
          var num = li.querySelector('.pd-level-up__widget-row-qty-num');
          if (num && num.textContent !== String(row.qty)) num.textContent = row.qty;
        }
      });

      // 清理 state 里已消失（或 qty<=0）的 row
      Object.keys(this.rowEls).forEach(function (id) {
        if (seen[id]) return;
        var el = self.rowEls[id];
        if (el && el.parentNode) el.parentNode.removeChild(el);
        delete self.rowEls[id];
      });

      this._syncEmptyRows(Math.max(0, MIN_ROWS - filledCount));

      if (this.countEl) this.countEl.textContent = n;
      if (this.totalEl) {
        // total 是 cents 整数；用 formatMoney + shop.money_format 输出含货币符号位置 + 本地分隔符的完整字符串
        // EU 站 (€1.234,56 EUR) / US 站 ($1,234.56) 都靠 shop.money_format 自动适配
        var fmt = (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) || '${{amount}}';
        if (typeof window.formatMoney === 'function') {
          this.totalEl.innerHTML = window.formatMoney(total, fmt);
        } else {
          this.totalEl.textContent = (total / 100).toFixed(2);
        }
      }
      if (this.ctaEl) {
        // n === 0 时 CTA 不可点击；loading 中保持 disabled，等请求结束再恢复
        if (!this.ctaEl.classList.contains('loading')) {
          this.ctaEl.setAttribute('aria-disabled', n > 0 ? 'false' : 'true');
        }
      }
      this._updateScrollFade();
    }

    _collectItems() {
      var self = this;
      var items = [];
      Object.keys(this.state).forEach(function (id) {
        var row = self.state[id];
        if (!row || row.qty <= 0) return;
        var vid = Number(row.variantId);
        if (!vid) return;
        items.push({ id: vid, quantity: row.qty });
      });
      return items;
    }

    _setCtaLoading(loading) {
      if (!this.ctaEl) return;
      this.ctaEl.classList.toggle('loading', loading);
      this.ctaEl.setAttribute('aria-busy', loading ? 'true' : 'false');
      this.ctaEl.setAttribute('aria-disabled', loading ? 'true' : 'false');
    }

    _onCtaAdd(e) {
      if (!this.ctaEl) return;
      e.preventDefault();
      if (this.ctaEl.classList.contains('loading')) return;
      if (this.ctaEl.getAttribute('aria-disabled') === 'true') return;
      var items = this._collectItems();
      if (!items.length) return;

      var self = this;
      this._setCtaLoading(true);

      var sectionsParam = cartSectionsToRender.map(function (s) { return s.section; }).join(',');
      var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionsParam, sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || (data && data.status)) {
              var msg = (data && (data.description || data.message)) || 'cart_add_failed';
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function (data) {
          if (data && data.sections) {
            cartSectionsToRender.forEach(function (s) {
              var host = document.getElementById(s.id);
              if (!host || !data.sections[s.section]) return;
              var target = host.querySelector(s.selector) || host;
              target.innerHTML = getSectionInnerHTML(data.sections[s.section], s.selector);
            });
            if (typeof Cart !== 'undefined') {
              try { new Cart().renderContents({ sections: data.sections }); } catch (_) {}
            }
          }
          var drawer = document.getElementById('Cart-Drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: { product: data && data.items ? data.items[0] : data }
            })
          );
          // GA4 埋点：bundle 总是走 multi-JSON path，response 形如 { items: [...] }
          var addedItems = data && data.items ? data.items : (data ? [data] : []);
          pdLuPushAddToCartGA4(addedItems, 'pd_level_up');
          // 加购成功后清空 widget，避免重复加购
          self.state = {};
          self._render();
        })
        .catch(function (err) {
          console.error('[pd-level-up] add to cart failed:', err);
          var msg = err && err.message ? err.message : '';
          if (window.pillarShowCartError) window.pillarShowCartError(msg);
        })
        .finally(function () {
          self._setCtaLoading(false);
          self._render();
        });
    }

    // 滚动区域上下渐隐：顶/底贴边或无溢出时对应 fade 设为 0
    _updateScrollFade() {
      if (!this.listEl) return;
      var FADE = 24;
      var max = this.listEl.scrollHeight - this.listEl.clientHeight;
      if (max <= 1) {
        this.listEl.style.setProperty('--pd-lu-fade-top', '0px');
        this.listEl.style.setProperty('--pd-lu-fade-bot', '0px');
        return;
      }
      var top = this.listEl.scrollTop;
      this.listEl.style.setProperty('--pd-lu-fade-top', top > 0 ? FADE + 'px' : '0px');
      this.listEl.style.setProperty('--pd-lu-fade-bot', top < max - 1 ? FADE + 'px' : '0px');
    }
  }

  window.customElements.define('pd-level-up', PdLevelUp);
})();
